import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { AttachMoney, LocalHospital, EventAvailable, HowToReg } from '@material-ui/icons';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';

import AlertModal from '../../../../shared/components/Modal';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ModalRequirementsStudio = ({ closeModal, action, opened, id_estudio, id_tercero,feasibility }) => {
    const history = useHistory();
    //Atributos
    const [number, setNumber] = React.useState(null);
    const [stateRequirement, setStateRequirement] = React.useState(false);
    const [description, setDescription] = React.useState(null);

    //Modal
    const [openModal, setOpenModal] = React.useState(opened);
    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }
    //Alerta
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const saveRequirement = () => {
        addRequirement();
    }

    const addRequirement = async () => {

        let dataReq = new FormData();
        dataReq.append("id_estudio", id_estudio);
        dataReq.append("id_tercero", id_tercero);
        dataReq.append("estado", stateRequirement);
        dataReq.append("numero", number);
        dataReq.append("descripcion", description);

        fetch(`${process.env.REACT_APP_PUBLIC_URL}requerimientos/create`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataReq
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                response.json()
            }
            else {
                throw new Error(``);
            }
        }).then(data => {
            let _url = "/clinical-studio/requirements";
            if (window.location.pathname === process.env.PUBLIC_URL + _url) {
                history.replace(process.env.PUBLIC_URL+"/");
                setTimeout(() => {
                    history.push({
                        pathname: process.env.PUBLIC_URL +_url,
                        state: feasibility
                    });
                }, 0);
            }
        }).catch(error => alertModal(false, "Ha ocurrido un error el servidor"));
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    setOpenModal(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>

                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Agregar Requerimiento</h5>
                        </div>

                        <Row>
                            <Col md={6}>
                                <TextField
                                    onChange={(e) => {
                                        setNumber(e.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    value={number}
                                    type='number'
                                    label="Número de Requerimiento"
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    id="standard-select-estado"
                                    select
                                    label=" "
                                    helperText="Estado Actual"
                                    value={stateRequirement}
                                    onChange={(event) => {
                                        setStateRequirement(event.target.value);
                                    }}
                                    disabled = {true}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={0} value={true}>
                                        Aprobado
                                    </MenuItem>
                                    <MenuItem key={1} value={false}>
                                        No Aprobado
                                    </MenuItem>
                                </TextField>
                            </Col>
                            <Col md={12}>
                                <TextField
                                    onChange={(e) => {
                                        setDescription(e.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    value={description}
                                    label="Descripcion"
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                saveRequirement();
                            }}
                        >
                            Crear
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal(false);
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalRequirementsStudio;
